import { Card, CardContent, CardHeader, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useWindTunnelStudy } from './context'

function WindTunnelStudyResult () {
  const { t } = useTranslation()
  const { form, result } = useWindTunnelStudy()

  const hidden = !form.formState.isSubmitSuccessful

  const isHidden = (
    hidden
    || result === null
    || result === undefined
  )

  if (isHidden) return <></>

  const resultString: string = result?.isNeedTesting === 1 ? t('GLOSSARY.REQUIRED') : t('GLOSSARY.NOT_REQUIRED')

  return (
    <Card>
      <CardHeader title={t('COMPOUND.RESULT', { label: 'GLOSSARY.WIND_TUNNEL_STUDY' })} />
      <CardContent className="flex flex-col gap-16">
        <TextField
          label={t('GLOSSARY.WIND_TUNNEL_STUDY_CRITERIA')}
          disabled
          value={result?.criteria.toFixed(2)}
        />
        <TextField
          label={t('GLOSSARY.WIND_TUNNEL_STUDY_WHETHER')}
          disabled
          type="text"
          value={resultString}
        />
      </CardContent>
    </Card>
  )
}

export default WindTunnelStudyResult
